import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {hideAppLoader, showAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import Config from "app/Config";

export const init = createAsyncThunk('IDFService/DataPackageExpansionInit', async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoaded(false));
        thunkAPI.dispatch(showAppLoader());
        const result = await ProviderManager.getProviderData('DataPackageExpansionInit', [data]);
        thunkAPI.dispatch(hideAppLoader());
        return result.Body;
    } catch (error) {
        thunkAPI.dispatch(hideAppLoader());
        return error;
    }
});

export const execute = createAsyncThunk('IDFService/DataPackageExpansion', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const result = await ProviderManager.getProviderData('DataPackageExpansionExecute', data);
        thunkAPI.dispatch(hideAppLoader());
        return result.Body;
    } catch (error) {
        thunkAPI.dispatch(hideAppLoader());
        return error;
    }
});

export const summaryReasons = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  SENIOR: 'SENIOR',
  MAX_PACKAGE: 'MAX_PACKAGE',
  OLD_PLAN: 'OLD_PLAN'
}
export const steps = {
    SELECTION: 'SELECTION',
    SUMMARY: 'SUMMARY'
}
const initialState = {
    currentPackage: null,
    selectedPackage: null,
    summaryReason: null,
    packages: null,
  isShowMoreDetails: false,
  currentStep: steps.SELECTION,
  loaded: false
};


const IdfSurfingPackageExpansionSlice = createSlice({
    name: 'IdfSurfingPackageExpansion',
    initialState: initialState,
    reducers: {
      resetState: () => initialState,
      setSelectedPackage: (state, action) => {
          state.selectedPackage = state.packages.find(p => p.packageObj.contentLink.id === action.payload.blockID);
            return state;
        },
      setStep: (state, action) => {
            state.currentStep = action.payload;
        },
      setLoaded: (state, action) => {
        state.loaded = action.payload;
      },
      saveToHistory: (state, action) => {
        return state;
      },
      toggleIsShowMoreDetails: (state, action) => {
        state.isShowMoreDetails = !state.isShowMoreDetails;
        return state;
      }
    },
    extraReducers: {
        [init.fulfilled]: (state, action) => {
            if (action.payload.isSuccess) {
                state.packages = action.payload.extra.packagesToDisplay;
                state.currentPackage = action.payload.extra.currentPackage;
            }
            else {
                state.summaryReason = action.payload.codeError;
                state.currentStep = steps.SUMMARY;
            }
          state.loaded = true;
            return state;
        },
      [init.rejected]: (state, action) => {
          state.summaryReason = summaryReasons.ERROR;
          state.currentStep = steps.SUMMARY;
          state.loaded = true;
          return state;
      },
      [execute.fulfilled]: (state, action) => {
            state.currentStep = steps.SUMMARY;
            state.summaryReason = action.payload.isSuccess ? summaryReasons.SUCCESS : summaryReasons.ERROR;
            return state;
        },
      [execute.rejected]: (state, action) => {
        state.summaryReason = summaryReasons.ERROR;
        state.currentStep = steps.SUMMARY;
        return state;
      }
    }
});

export const {
    resetState,
    setSelectedPackage,
  setStep,
  setLoaded,
  saveToHistory,
  toggleIsShowMoreDetails
} = IdfSurfingPackageExpansionSlice.actions;

export default IdfSurfingPackageExpansionSlice.reducer;
